module.exports = __webpack_public_path__ + "img/grid3.c17c5f4.png";